import React from 'react';
import { Icon, Spinner, Text, chakra } from '@chakra-ui/react';
import { LuMessageCircleQuestion } from 'react-icons/lu';
import { useCoveSupport } from './useCoveSupport';

/**
 * Header entry point for the Cove support widget. A <button>, not a link: it
 * performs an in-page action and has no href. Styled to match the header's
 * "Sign In" link so the two read as one row of small-caps actions.
 */
export const NeedHelpButton: React.FC = () => {
  const { available, opening, open } = useCoveSupport();
  if (!available) return null;

  return (
    <chakra.button
      type="button"
      onClick={open}
      disabled={opening}
      aria-busy={opening}
      aria-label="Need help? Open support chat"
      display="inline-flex"
      alignItems="center"
      gap="1.5"
      mr="4"
      bg="transparent"
      border="none"
      p="0"
      cursor={opening ? 'progress' : 'pointer'}
      color="fg.muted"
      fontSize="xs"
      letterSpacing="wider"
      textTransform="uppercase"
      _hover={{ color: 'fg' }}
      _focus={{ outline: 'none' }}
      _focusVisible={{ outline: '2px solid', outlineColor: 'river.solid', outlineOffset: '4px' }}
    >
      {opening ? <Spinner size="xs" /> : <Icon as={LuMessageCircleQuestion} boxSize="4" aria-hidden />}
      <Text as="span">Need Help?</Text>
    </chakra.button>
  );
};
